import { Controller } from 'lib_ts/enums/routing/controllers';
import { AdminErrorTypesRoutes } from 'lib_ts/enums/routing/routes/admin-error-types';
import { IServerResponse } from 'lib_ts/interfaces/common/i-server-response';
import { IBallTypeConfig } from 'lib_ts/interfaces/i-ball-types';
import { BaseRESTService } from 'services/_base-rest.service';

export class AdminBallTypesService extends BaseRESTService {
  private static instance: AdminBallTypesService;
  static getInstance(): AdminBallTypesService {
    if (!AdminBallTypesService.instance) {
      AdminBallTypesService.instance = new AdminBallTypesService();
    }

    return AdminBallTypesService.instance;
  }

  private constructor() {
    super({
      controller: Controller.AdminBallTypes,
    });
  }

  async getAll(): Promise<IBallTypeConfig[]> {
    return await this.get({
      uri: AdminErrorTypesRoutes.Root,
    });
  }

  async update(
    data: Partial<IBallTypeConfig>
  ): Promise<IBallTypeConfig | undefined> {
    if (!data._id) {
      throw new Error('Cannot put without id');
    }

    return await this.put(
      {
        uri: AdminErrorTypesRoutes.Root,
      },
      data
    )
      .then((result: IServerResponse) => {
        if (!result.success) {
          console.error(
            result.error ??
              'There was a problem updating the ball type configuration.'
          );
          return undefined;
        }

        return result.data as IBallTypeConfig;
      })
      .catch((e) => {
        console.error(e);
        return undefined;
      });
  }
}
